import { HFlow, Text, VFlow } from 'bold-ui'
import { DateTime } from 'components/date'
import { Age } from 'components/date/Age'
import { Cpf } from 'components/label'
import React from 'react'
import { identidadeGenero, sexo } from 'types/enums'
import { titleCase } from 'util/strConversor'
import { CidadaoListingFormModel } from 'view/cidadao/types/CidadaoPesquisarFormModel'
interface UnificacaoCidadaoCardInfoProps {
  cidadao: CidadaoListingFormModel
  testid: string
}

export default function UnificacaoCidadaoCardInfo({ cidadao, testid }: UnificacaoCidadaoCardInfoProps) {
  return (
    <>
      <VFlow vSpacing={0} style={{ width: 350 }}>
        <HFlow>
          <HFlow hSpacing={0.5} data-testid={testid + cidadao.id + '.CPF'}>
            <Text fontWeight='bold'>CPF</Text>
            {cidadao.cpf ? <Cpf value={cidadao.cpf} /> : '-'}
          </HFlow>
          <HFlow hSpacing={0.5} data-testid={testid + cidadao.id + '.CNS'}>
            <Text fontWeight='bold'>CNS</Text>
            {cidadao.cns ? <Text>{cidadao.cns}</Text> : '-'}
          </HFlow>
        </HFlow>
        <HFlow hSpacing={0.5} data-testid={testid + cidadao.id + '.DataNascimento'}>
          <Text fontWeight='bold'>Data de nascimento</Text>
          <DateTime format='DD/MM/YYYY' value={cidadao.dataNascimento} />
          <Age dateOfBirth={cidadao?.dataNascimento} />
        </HFlow>
        <HFlow hSpacing={0.5}>
          <Text fontWeight='bold'>Sexo</Text>
          <Text data-testid={testid + cidadao.id + '.Sexo'}> {sexo[cidadao.sexo]}</Text>
          <Text fontWeight='bold'>{cidadao.identidadeGeneroDbEnum ? 'Id. de gênero' : null}</Text>
          <Text data-testid={testid + cidadao.id + '.IdGenero'}>
            {' '}
            {cidadao.identidadeGeneroDbEnum && identidadeGenero[cidadao.identidadeGeneroDbEnum]}
          </Text>
        </HFlow>
      </VFlow>
      <VFlow vSpacing={0}>
        <HFlow data-testid={testid + cidadao.id + '.NomeMae'}>
          <Text fontWeight='bold'>Nome da mãe</Text>
          <Text>{cidadao.nomeMae ? titleCase(cidadao.nomeMae) : '-'}</Text>
        </HFlow>
        <HFlow data-testid={testid + cidadao.id + '.UnidadeResponsavel'}>
          <Text fontWeight='bold'>Unidade responsável</Text>
          <Text>{titleCase(cidadao.cidadaoVinculacaoEquipe?.unidadeSaude?.nome) ?? '-'}</Text>
        </HFlow>
        <HFlow data-testid={testid + cidadao.id + '.MunicipioNascimento'}>
          <Text fontWeight='bold'>Município de nascimento</Text>
          <Text>
            {cidadao.localidadeNascimento?.nome
              ? `${titleCase(cidadao.localidadeNascimento?.nome)} - ${cidadao.localidadeNascimento?.uf?.sigla}`
              : '-'}
          </Text>
        </HFlow>
      </VFlow>
    </>
  )
}
